import {
  ExecuteTextPromptQuery,
  ExecuteTextPromptQueryVariables,
} from '../__generated__/queries-web';
import { client } from '../apollo';
import { EXECUTE_TEXT_PROMPT } from '../apollo/queries/execute-text-prompt.web.graphql';

/** Same default as articleSummary (`generateArticleSummary`). */
const DEFAULT_MODEL = 'openai/gpt-5.2';

export const callOpenAI = async (
  content: string,
  maxCompletionTokens?: number,
  temperature?: number,
  model: string = DEFAULT_MODEL,
) => {
  return await client.query<
    ExecuteTextPromptQuery,
    ExecuteTextPromptQueryVariables
  >({
    fetchPolicy: 'no-cache',
    query: EXECUTE_TEXT_PROMPT,
    variables: {
      prompt: content,
      model,
      max_completion_tokens: maxCompletionTokens,
      temperature,
      response_format: {
        type: 'json_object',
      },
    },
  });
};
